import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

export function RatingInput({ value, onChange, disabled, className }) {
  const ratings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  
  return (
    <div className={cn("space-y-3", className)}>
      <div className="flex flex-wrap gap-2 justify-center" data-testid="rating-input">
        {ratings.map((rating) => (
          <button
            key={rating}
            type="button"
            disabled={disabled}
            onClick={() => onChange(value === rating ? null : rating)}
            className={cn(
              "rating-btn touch-target",
              value === rating && "active"
            )}
            data-testid={`rating-btn-${rating}`}
            aria-label={`Rate ${rating} out of 10`}
          >
            {rating}
          </button>
        ))}
      </div>
      
      <div className="flex justify-center">
        <Button
          type="button"
          variant={value === null ? "secondary" : "ghost"}
          size="sm"
          onClick={() => onChange(null)}
          disabled={disabled}
          className={cn(
            "text-xs",
            value === null && "bg-muted font-medium"
          )}
          data-testid="rating-btn-na"
        >
          N/A - Not Applicable
        </Button>
      </div>
      
      <div className="flex justify-between text-xs text-muted-foreground px-2">
        <span>Needs work</span>
        <span>Excellent</span>
      </div>
    </div>
  );
}
